"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoastalErosionEstimatedDistanceLostTermRisk$ = exports.CoastalErosionEstimatedDistanceLostTermRisk$outboundSchema = exports.CoastalErosionEstimatedDistanceLostTermRisk$inboundSchema = void 0;
exports.coastalErosionEstimatedDistanceLostTermRiskToJSON = coastalErosionEstimatedDistanceLostTermRiskToJSON;
exports.coastalErosionEstimatedDistanceLostTermRiskFromJSON = coastalErosionEstimatedDistanceLostTermRiskFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const coastalerosionriskrating_js_1 = require("./coastalerosionriskrating.js");
/** @internal */
exports.CoastalErosionEstimatedDistanceLostTermRisk$inboundSchema = z.object({
    risk_rating: z.nullable(coastalerosionriskrating_js_1.CoastalErosionRiskRating$inboundSchema),
    risk_value: z.nullable(z.number()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "risk_rating": "riskRating",
        "risk_value": "riskValue",
    });
});
/** @internal */
exports.CoastalErosionEstimatedDistanceLostTermRisk$outboundSchema = z.object({
    riskRating: z.nullable(coastalerosionriskrating_js_1.CoastalErosionRiskRating$outboundSchema),
    riskValue: z.nullable(z.number()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        riskRating: "risk_rating",
        riskValue: "risk_value",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var CoastalErosionEstimatedDistanceLostTermRisk$;
(function (CoastalErosionEstimatedDistanceLostTermRisk$) {
    /** @deprecated use `CoastalErosionEstimatedDistanceLostTermRisk$inboundSchema` instead. */
    CoastalErosionEstimatedDistanceLostTermRisk$.inboundSchema = exports.CoastalErosionEstimatedDistanceLostTermRisk$inboundSchema;
    /** @deprecated use `CoastalErosionEstimatedDistanceLostTermRisk$outboundSchema` instead. */
    CoastalErosionEstimatedDistanceLostTermRisk$.outboundSchema = exports.CoastalErosionEstimatedDistanceLostTermRisk$outboundSchema;
})(CoastalErosionEstimatedDistanceLostTermRisk$ || (exports.CoastalErosionEstimatedDistanceLostTermRisk$ = CoastalErosionEstimatedDistanceLostTermRisk$ = {}));
function coastalErosionEstimatedDistanceLostTermRiskToJSON(coastalErosionEstimatedDistanceLostTermRisk) {
    return JSON.stringify(exports.CoastalErosionEstimatedDistanceLostTermRisk$outboundSchema.parse(coastalErosionEstimatedDistanceLostTermRisk));
}
function coastalErosionEstimatedDistanceLostTermRiskFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.CoastalErosionEstimatedDistanceLostTermRisk$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'CoastalErosionEstimatedDistanceLostTermRisk' from JSON`);
}
//# sourceMappingURL=coastalerosionestimateddistancelosttermrisk.js.map